export const BOOKING_SLOT_OPTIONS = [
  "09:00 AM - 10:00 AM",
  "10:00 AM - 11:00 AM",
  "11:00 AM - 12:00 PM",
  "12:00 PM - 01:00 PM",
  "02:00 PM - 03:00 PM",
  "03:00 PM - 04:00 PM",
  "04:00 PM - 05:00 PM",
  "05:00 PM - 06:00 PM",
];

export function buildDateSlotKey(dateValue = "", slotValue = "") {
  const date = String(dateValue || "").trim();
  const slot = String(slotValue || "").trim().toLowerCase();
  if (!date || !slot) return "";
  return `${date}::${slot}`;
}

export function parseDateSlotKey(value = "") {
  const text = String(value || "").trim();
  if (!text.includes("::")) {
    return { date: "", slot: "" };
  }
  const [date, ...slotParts] = text.split("::");
  return {
    date: String(date || "").trim(),
    slot: slotParts.join("::").trim(),
  };
}
